{
  "alerts": {
    "cantCreateProperty": "Помилка, не вдалося оновити інформацію про помешкання. Спробуйте ще раз пізніше.",
    "cantCreateUser": "Помилка, неможливо створити користувача. Будь ласка, спробуйте ще раз пізніше.",
    "cantCancelReservation": "Помилка, не вдалося скасувати бронювання. Спробуйте ще раз пізніше.",
    "cantCancelSubscription": "Помилка, не вдалося скасувати підписку. Спробуйте ще раз пізніше.",
    "cantUpdate": "Помилка, не вдалося оновити інформацію. Спробуйте ще раз пізніше.",
    "cantUpdateReservtion": "Помилка, не вдалося оновити бронювання. Спробуйте ще раз пізніше або зверніться до нас.",
    "emailIsIncorrect": "Адреса електронної пошти неправильна. Будь ласка, переконайтеся, що введена адреса введена правильно",
    "googlePlayServicesNotAvailable": "Google Play Services недоступні на вашому пристрої.",
    "locationNotEnabledDescription": "Вам потрібно увімкнути місцезнаходження, щоб мати змогу виконувати замовлення.",
    "locationNotEnabledTitle": "Увімкніть місцезнаходження",
    "mandatoryUpdateMessage": "Є доступне оновлення, яке необхідно встановити.",
    "outdatedPaymentMethod": "Обраний спосіб оплати застарів. Оновіть спосіб оплати та спробуйте ще раз.",
    "paymentFailed": "Виникла помилка під час оплати.\nЗв'яжіться з підтримкою або спробуйте ще раз.",
    "sthWentWrong": "Помилка, щось пішло не так.\nЗв'яжіться з підтримкою або спробуйте ще раз.",
    "unavailableLocalization": "Ваше розташування ще не доступне",
    "update": "Оновити",
    "updateTitle": "Оновлення доступне",
    "userWithEmailAlreadyExists": "Користувач з такою електронною адресою вже існує"
  },
  "common": {
    "accept": "Прийняти",
    "add": "Додати",
    "added": "Додано",
    "at": "at",
    "cancel": "Скасувати",
    "chat": "Чат",
    "change": "Змінити",
    "choose": "Оберіть",
    "choosePhoto": "Вибрати фото",
    "chosen": "Вибраний",
    "clear": "Очистити",
    "close": "Закрити",
    "closePage": "Закрити сторінку",
    "continue": "Продовжити",
    "date": "Дата",
    "default": "Default",
    "delete": "Видалити",
    "deleteService": "Видаліть %{service}",
    "details": "деталі",
    "discount": "Знижка",
    "done": "Виконано",
    "edit": "Редагувати",
    "error": "Помилка",
    "email": "Електронна пошта",
    "from": "Від",
    "goBack": "Повернутися",
    "help": "Допоможіть",
    "hi": "Привіт! 👋",
    "hours": "год.",
    "id": "ID",
    "menu": "Меню",
    "name": "Ім'я",
    "no": "Ні",
    "OK": "Добре",
    "or": "Lub",
    "order": "Замовлення",
    "phone": "Номер телефону",
    "popular": "Популярний",
    "price": "Ціна",
    "return": "Повернення",
    "save": "Зберегти",
    "service": "Служба",
    "skip": "Пропустити",
    "stripe": "Stripe",
    "takePhoto": "Зробити фото",
    "time": "Час",
    "together": "Разом",
    "tryAgain": "Спробуйте ще раз",
    "understand": "Я розумію",
    "update": "Оновити",
    "whether": "Або",
    "yes": "Так"
  },
  "components": {
    "drawer": {
      "aboutStepapp": "Про Stepapp",
      "coupons": "Купони",
      "covid19": "Наша відповідь на Covid-19",
      "covid19Response": "Наша відповідь на Covid-19",
      "downloadApp": "Завантажити додаток",
      "help": "Допомога",
      "hey": "Привіт!",
      "heyYou": "Привіт %{name}!",
      "payments": "Платежі",
      "referAFriend": "Запросити друзів",
      "settings": "Налаштування",
      "showProfile": "Показати профіль",
      "support": "Підтримка",
      "writeToUs": "Напишіть нам"
    },
    "footer": {
      "about": "Про нас",
      "app": "Додаток",
      "blog": "Блог",
      "cancellationRules": "Політика скасування",
      "cleaningPersonnel": "Прибиральники",
      "contact": "Контакт",
      "contactHours": "Пн-Сб 9:30-18:00",
      "cookies": "Ми використовуємо файли cookie, завдяки яким наш сайт працює належним чином.",
      "daysAgo": "днів тому",
      "disclaimerPL": "Stepapp - це Stepapp sp. z.o.o., зареєстрована у Варшавському реєстрі польського суду під номером 0000896336. ІПН: 5252860294.",
      "disclaimerNO": "Stephome AS зареєстрована в Осло.",
      "FAQ": "Часті запитання",
      "learnMore": "Дізнайтеся більше",
      "myths": "Міфи про прибирання",
      "privacyPolicy": "Політика конфіденційності",
      "reviews": "Відгуки",
      "safePayment": "Безпечні платежі",
      "termsOfUse": "Умови використання",
      "today": "сьогодні",
      "workers": "Прибирання працівників",
      "worthKnowing": "Добре знати",
      "yesterday": "вчора"
    },
    "header": {
      "aboutStepapp": "Про Stepapp",
      "coupons": "Купони",
      "help": "UnsupportedLanguagePair",
      "inviteFriends": "Запросити друзів",
      "payments": "Оплати",
      "profile": "Профіль",
      "register": "Зареєструватися",
      "services": "Послуги",
      "settings": "Налаштування",
      "showProfile": "Показати профіль",
      "signIn": "Увійти",
      "support": "Підтримка",
      "writeToUs": "Напишіть нам"
    },
    "input": {
      "placeholder": {
        "additionalInstructions": "Приклад: Будь ласка, постукайте у двері замість використання дзвінка.",
        "addNote": "Додайте додатковий опис (необов'язково)",
        "addressFirstLine": "Адреса 1-го рядка",
        "addressSecond": "Друга лінія адреси",
        "addressSecondLine": "Адреса 2-го рядка",
        "apartmentNumber": "Номер квартири (необов'язково)",
        "city": "Місто",
        "companyName": "Назва компанії",
        "doorCode": "Код дверей (необов'язково)",
        "email": "Електронна пошта",
        "firstName": "Ім'я",
        "homeDescription": "На що ми повинні зосередитися найбільше під час надання послуг",
        "housing": "Оселя (необов'язково)",
        "keyInfo": "Де ви залишите ключ? Наприклад, «Ключ буде під фіолетовим горщиком, ліворуч від дверей»",
        "lastName": "Прізвище",
        "NIPNumber": "Номер NIP",
        "postalCode": "Введіть поштовий код",
        "propertyName": "Назва будинку",
        "size": "Введіть квадратні метри",
        "street": "Вулиця",
        "typeAddress": "Введіть адресу"
      }
    },
    "houseAreaOutOfScope": {
      "houseAreaIsTooLarge": "Введена площа будинку занадто велика.",
      "orderForLargerHouseArea": "Бажаєте замовити прибирання для більшої площі? Зв'яжіться з нами!",
      "writeAndOrderCustomCleaning": "Хочу замовити індивідуальне прибирання"
    },
    "paymentOptions": {
      "type_apple": "Apple Pay",
      "type_google": "Google Pay"
    },
    "shareCouponSheet": {
      "copy": "Копіювати",
      "description": "Отримайте 40 злотих і дайте 40 злотих своєму другу, поділившись цим кодом, і він/вона використає його при оформленні замовлення!",
      "discountExplanation": "Мінімальна вартість замовлення - 100 злотих.",
      "share": "Поділитися",
      "shareMessage": "Я відправляю вам %{codeValue} знижки на ваше перше прибирання в додатку Stepapp. Щоб скористатися, введіть код %{referralCode} під час розміщення замовлення!\nПосилання для розміщення замовлення: %{appUrl}",
      "title": "Invalid Source Language Code"
    },
    "tabBar": {
      "application": "Додаток",
      "calendar": "Календар",
      "dashboard": "Замовлення",
      "myHome": "Мої адреси",
      "openApp": "Відкрити додаток",
      "stepappApp": "Додаток Stepapp",
      "stepappAppDescription": "Завантажте наш мобільний додаток, щоб бути в курсі своїх замовлень та не пропустити акції та повідомлення від нашої служби підтримки!",
      "stepappMobileApp": "Мобільний додаток Stepapp"
    },
    "tabBar_Calendar": "Календар",
    "tabBar_Dashboard": "Замовлення",
    "tabBar_MyHome": "Мій дім"
  },
  "dialogs": {
    "couponActivated": "Купон додано",
    "couponAdded": "Гаманець Stepapp поповнено на суму %{amount}",
    "couponCreditsAdded": "Ваш гаманець поповнено новими кредитами для використання в додатку Stepapp.",
    "couponFindOtherAndTryAgain": "Або це неправильно. Перевірте на наявність помилок та спробуйте ввести ще раз.",
    "couponInvalid": "Код \"%{coupon}\" недійсний або застарілий.",
    "couponUsed": "Код вже використовувався",
    "later": "Пізніше",
    "multiPersonServiceInfoMessage": "Пам'ятайте, що одне бронювання закріплено за одним виконавцем послуги. Якщо ви бронюєте послугу для більше ніж однієї особи, той самий виконавець обслуговуватиме їх одну за одною. Якщо ви хочете замовити послугу для двох осіб одночасно, потрібно створити два окремих замовлення та зазначити це у нотатках до замовлення.",
    "multiPersonServiceInfoTitle": "Інформація про послуги для більше ніж 1 особи",
    "negativeRateTitle": "Будьте впевнені, що написавши нам, що можна змінити або покращити, ви допоможете нам багато!",
    "ofCourse": "Звичайно",
    "positiveRateTitle": "Супер! 🤘 Будь ласка, оцініть нашу програму. Ми будемо більш ніж вдячні за ваш відгук!",
    "rateTitle": "Чи подобається вам використання Stepapp?"
  },
  "notifications": {
    "accountDeletion": {
      "description": "Процедура видалення вашого облікового запису розпочалася. Це може зайняти до 7 днів.",
      "title": "Обліковий запис у процесі видалення"
    },
    "permissionDenied": {
      "camera": "Ви не маєте дозволу використовувати камеру.",
      "cameraDescription": "Перейдіть до налаштувань, щоб дозволити використання камери.",
      "notifications": "Увімкніть сповіщення в налаштуваннях додатку",
      "notificationsDescription": "Ми використовуємо повідомлення, щоб своєчасно повідомляти вас про оновлення, що стосуються замовлень. Без їх увімкнення додаток може не працювати належним чином."
    }
  },
  "pages": {
    "auth": {
      "basicInfoDescription": "Ми просимо лише необхідні дані.\nВаша електронна адреса та прізвище будуть видимі тільки для нас.",
      "registerInStepapp": "Зареєструйтесь в Stepapp."
    },
    "chooseCard": {
      "addCard": "Додати картку",
      "addCardFailed": "Додавання картки не вдалося",
      "addCardFailedDescription": "Перевірте введені дані або спробуйте пізніше",
      "cardRecurringPaymentsInfo": "Ваша картка буде призначена для вашого облікового запису Stepapp та використовуватиметься для регулярних послуг. Ви завжди можете змінити її в налаштуваннях.",
      "cardNotSupportThisPayment": "Ваша картка не підтримує цей тип платежу. Спробуйте додати іншу картку.",
      "chooseCard": "Виберіть карту",
      "confirm": "Підтвердити",
      "newCard": "Нова картка"
    },
    "serviceDateAndAddress": {
      "addAddress": "Додати адресу",
      "addAddressDescription_cleaning": "Надайте детальну інформацію, щоб ми могли почати прибирання без перешкод.",
      "addAddressDescription_massage": "Надайте докладну інформацію, щоб ми могли розпочати масаж без затримок.",
      "addAddressDescription_other": "Надайте докладну інформацію, щоб ми могли розпочати послугу без затримок.",
      "additionalInfo": "Додаткова інформація",
      "addressForm": {
        "address": "Вулиця та номер будинку",
        "addressSecond": "Другий рядок адреси",
        "city": "Місто",
        "doorCode": "Код шлюзу",
        "iWillBeThere": "Я буду вдома",
        "iWillLeaveTheKey": "Я залишу ключ",
        "numberOrHousing": "Номер квартири",
        "postalCode": "Поштовий індекс"
      },
      "chooseHour": "Виберіть час",
      "continueLabel": "Наступний крок - підсумок та оплата",
      "description": "Виберіть дату та час для початку послуги",
      "howAreWeGoingToEnter": "Як нам потрапити до вашого будинку?",
      "howAreWeGoingToEnterDescription": "Це додаткова інформація, яка допоможе нам виконати прибирання без проблем. Ви можете додати її пізніше.",
      "instructionsForArrival": "Інструкції щодо прибуття",
      "iWillBeThere": "Я буду вдома",
      "iWillLeaveTheKey": "Я залишу ключ",
      "provideAddress": "Введіть адресу",
      "provideAddressTitle": "Введіть адресу для надання послуги",
      "provideAddressToCheckAvailability": "Завдяки адресі ми зможемо визначити доступність наших послуг",
      "title": "Коли ми починаємо?"
    },
    "serviceSummary": {
      "addCard": "Додати картку",
      "additionalServices": "Додаткові послуги",
      "address": "Адреса",
      "cancellationRules": "Політика скасування",
      "cancellationRulesDescription": "Скасуйте свою бронь до %{date}, щоб уникнути додаткових витрат. Скасування після цього часу призведе до додаткових витрат у розмірі до 50% вартості замовлення.",
      "cardDescription": "Ми заблокуємо кошти лише за 48 годин до прибирання. Однак збір коштів відбудеться лише в день прибирання.",
      "couponList": "Список купонів",
      "dateNotAvailable": "Обрана вами дата вже недоступна. Поверніться до календаря та оберіть нову дату прибирання.",
      "description": "Перегляньте своє замовлення ще раз і переконайтеся, що все вірно",
      "doYouNeedVATInvoice": "Нужен счет-фактура?",
      "enterCoupon": "Введіть купон",
      "haveCoupon": "Ви маєте купон?",
      "haveCouponDescription": "Ви можете додати купон після входу або реєстрації.",
      "howAreWeGoingToEnter": "Як ми можемо потрапити до вашої квартири?",
      "instantPaymentCardDescription": "Ми зберемо всю суму, як тільки ви зробите замовлення, тому що до початку замовлення залишилося менше 48 годин.",
      "instantPaymentInfo": "Фонди вашої картки будуть зняті негайно, оскільки залишилося менше 48 годин до початку послуги.",
      "instantPaymentRules": "Ваше бронювання почнеться раніше, ніж за 48 годин. Скасування після цього часу буде супроводжуватись додатковими витратами до 50% вартості замовлення.",
      "invoiceAdditionalEmail": "Ви можете додати додаткову електронну адресу для відправлення рахунку. Якщо залишите поле порожнім, ми відправимо рахунок на електронну адресу вашого облікового запису.",
      "invoiceBeforeSubmit": "Ви можете зробити це лише перед поданням замовлення.",
      "loginToViewDetails": "Увійдіть або зареєструйтесь, щоб зробити замовлення",
      "nextSteps": "Наступні кроки",
      "nextStepsDescription_cleaning": "Після того, як ви зробите бронювання, ми призначимо одного з наших чудових прибиральників, доступних у вашому районі. Ви зустрінете її в додатку перед початком прибирання.",
      "nextStepsDescription_massage": "Після оформлення бронювання ми призначимо одного з наших масажистів, доступних у вашому районі. Ви познайомитеся з ним у додатку перед початком послуги.",
      "nextStepsDescription_other": "Після оформлення бронювання ми призначимо одного з наших спеціалістів, доступних у вашому районі. Ви познайомитеся з ним у додатку перед початком послуги.",
      "pay_blik": "Сплатіть за допомогою BLIK",
      "pay_przelewy24": "Сплатіть за допомогою Przelewy24",
      "payNow": "Сплатити зараз",
      "payNowDescription": "Зверніть увагу, що якщо ви замовляєте регулярну прибирання, ми попросимо вас додати карту до вашого бронювання. Проте ви все ще можете оплатити перше прибирання з допомогою BLIK або Przelewy24. На жаль, ми не приймаємо готівкові платежі.",
      "SMSInfo": "Ми відправимо код SMS на вказаний вами номер телефону. Введіть його, щоб підтвердити свій вхід або реєстрацію.",
      "startDate": "Дата початку",
      "title": "Опис",
      "total": "Буде оплачено",
      "VATInvoice": "Рахунок-фактура з ПДВ",
      "VATInvoiceInfo": "Напишіть нам в чаті (\"Допомога\") одразу після оформлення замовлення та надайте дані для рахунку-фактури.",
      "wantToGetVATInvoice": "Я хочу отримати рахунок-фактуру з ПДВ",
      "yourStepappWallet": "Ваш гаманець Stepapp"
    }
  },
  "screens": {
    "accommodation": {
      "description": "Нам потрібно знати тип вашої квартири, щоб забезпечити найкращий досвід у Stepapp",
      "title": "Де ви живете?",
      "type_APARTMENT": "Квартира",
      "type_HOUSE": "Будинок"
    },
    "appUpdate": {
      "description": "Ми щойно випустили нове, довгоочікуване оновлення нашої системи та додатку. Відбулося багато змін, але нижче ми представляємо найважливіші з них:",
      "feature1": "[Нове] Можливість редагування бронювань з рівня додатка, додавання нових послуг.",
      "feature2": "[Нове] Можливість зміни терміну з рівня додатка.",
      "feature3": "[Нове] Розумний календар доступності",
      "feature4": "[Нове] Платежі Apple Pay/Google Pay.",
      "feature5": "[Нове] Легше управління платежами.",
      "title": "Привіт! Ласкаво просимо до Stepapp 2.0."
    },
    "auth": {
      "alreadyHaveAccount": "У вас вже є обліковий запис?",
      "iHaveAccount": "Я вже маю обліковий запис",
      "inWhichCity": "У якому місті ви хочете перевірити наші послуги?",
      "letsStart": "Початок",
      "logIn": "Увійти",
      "logInWith": "Увійти через %{provider}",
      "order": "Замовити послугу",
      "register": "Зареєструватися",
      "welcomeMessage": "Ми допоможемо вам з домашніми справами, щоб ви мали більше вільного часу щодня!",
      "welcomeMessage1": "Ми допоможемо вам з побутовими справами, завдяки чому ви зможете отримати",
      "welcomeMessage2": "більше вільного часу",
      "welcomeMessage3": "кожен день!",
      "whereDoYouLive": "Де ти живеш?"
    },
    "bookedServices": {
      "downloadApp": "Завантажте додаток Stepapp",
      "emptyBookings": "У вас немає запланованих послуг. Замовте послугу від Stepapp та автоматизуйте своє життя вдома!",
      "order": "Замовити послугу",
      "showCompleted": "Перевірте виконані послуги",
      "toTrackProgress": ", щоб в режимі реального часу відстежувати прогрес ваших бронювань."
    },
    "calendar": {
      "additionalCardVerification": "Можливо, ваша карта потребує додаткової перевірки.",
      "cantFindDate": "Не бачите зручної дати?",
      "failedCardPayment": "Ми не змогли здійснити оплату з вашої карти",
      "hide": "Сховати",
      "notRegistered": "Тут, як зареєстрований користувач, ви зможете побачити свої майбутні бронювання.",
      "paymentFailed": "Нам не вдалося здійснити оплату",
      "paymentFailedDescription": "Оновіть спосіб оплати, щоб уникнути заборгованостей",
      "serviceScheduleInfo": "Ми відображаємо лише найближчі заплановані зустрічі. Пізніші зустрічі з'являться після того, як буде завершено перше наближче обслуговування. Якщо ви бажаєте зробити зміни на пізніші дати,",
      "settlePayment": "Врегулюйте оплату",
      "showLaterReservations": "Показати більше бронювань",
      "title": "Мої бронювання",
      "updatePayment": "Оновіть спосіб оплати",
      "writeToUs": "Напишіть нам"
    },
    "cancelReservation": {
      "addDiscount": "Додайте до свого гаманця у вкладці 'Платежі', і оплата за наступну послугу з цього бронювання зменшиться на %{discount}.",
      "cancelAllScheduledAppointments": "Ми скасуємо всі заплановані записи з цієї підписки.",
      "cancelAppointment": "Скасувати цей запис %{fee}",
      "cancelEntireSubscription": "Скасувати всю підписку %{fee}",
      "cancelReservation": "Скасувати бронювання",
      "cancelSubscription": "Скасувати підписку %{fee}",
      "cancelSingleReservationInSubscription": "Ви скасовуєте лише один окремий запис (%{date}). Новий запис буде створено відповідно до частоти вашої підписки.",
      "cancelSubscriptionWithCost": "Ви також можете скасувати всю підписку, але вам все одно доведеться сплатити за скасування цього запису.",
      "cancelOrEditReservation": "Ви можете скасувати всю бронювання або змінити дату.",
      "confirmCancelReservation": "Відмініть цей запис %{fee}",
      "confirmCancelSubscription": "Відмініть підписку %{fee}",
      "dontCancelAppointment": "Я не хочу скасовувати запис",
      "dontCancelSubscription": "Я не хочу скасовувати підписку",
      "insteadOfPaying": "Замість того, щоб платити %{fee}, ви можете заощадити %{discount}!",
      "maybeConsiderResubscribe": "Можливо, ви розглянете можливість повторного підключення?",
      "newAddressDiscount": "Замовте прибирання за новою адресою зі знижкою.",
      "nextServiceDiscount": "-%{discount} на наступну послугу.",
      "reservationCanceled": "Бронювання скасовано.",
      "serviceCancellation": "Скасування послуги.",
      "specialOffer": "Ми підготували для вас спеціальну пропозицію.",
      "staySubscribed": "Залишайтеся підписаними та скористайтеся пропозицією",
      "subscriptionCanceled": "Підписку скасовано.",
      "weWantToImprove": "Ми постійно прагнемо покращуватися, і ваша думка має значення.",
      "whyCancelReservation": "Чому ви хочете скасувати бронювання?",
      "whyCancelSubscription": "Чому ви хочете скасувати підписку?",
      "cancelCause": {
        "haveBetterOffer": "Я маю кращу пропозицію",
        "movingToANewPlace": "Я змінюю місце проживання",
        "noLongerNeedTheService": "Мені більше не потрібні послуги.",
        "other": "Інше",
        "problemWithPlatform": "У мене проблема з платформою Stepapp",
        "problemWithWorker": "У мене проблема з призначеною особою",
        "serviceNotGoodEnough": "Послуга не відповідає моїм очікуванням"
      }
    },
    "chat": {
      "writeMessage": "Напишіть повідомлення"
    },
    "completedServices": {
      "completed": "Translation not supported for requested language pair",
      "emptyCompleted": "У вас немає завершених послуг. Замовте послугу від Stepapp та поставте свій будинок на автопілот!",
      "title": "Завершені бронювання"
    },
    "coupons": {
      "addCoupons": "Додати до замовлення",
      "description": "У вас є промокод або код гаманця Stepapp?",
      "emptyCoupons": "Купони недоступні",
      "giveAndReceiveDiscount": "Отримайте 40 злотих, заплативши 40 злотих",
      "removeCoupons": "Видалити з замовлення",
      "shareMailSubject": "Stepapp",
      "shareMessage": "Гей, я знайшов для вас 40 злотих на домашні послуги від Stepapp! %{voucherCode}",
      "title": "Купони",
      "typeCode": "Введіть код",
      "validTo": "Дійсний до %{date}",
      "walletFundsDescription": "Кошти з гаманця будуть використані для оплати найближчої послуги.",
      "yourDiscounts": "Ваші знижки"
    },
    "dashboard": {
      "articlesTitle": "Блог Stepapp",
      "bookNow": "Замовити",
      "chooseCategory": "Оберіть категорію",
      "chooseCity": "Оберіть місто",
      "couldntProcessPayment": "Ми не змогли здійснити оплату за прибирання",
      "hygiene": "Гігієна",
      "hygieneDescription": "Ми маємо жорсткі стандарти гігієни та нульову толерантність до порушення правил безпеки.",
      "insurance": "Страхування відповідальності",
      "insuranceDescription": "Кожна бронювання в Stepapp покрита страхуванням відповідальності на суму 1 000 000 злотих.",
      "liabilityInsurance": "Страхування відповідальності на суму 1 мільйон зл",
      "mostPopularServices": "Найпопулярніші послуги",
      "proposeCity": "Запропонуйте місто",
      "reliability": "Надійність",
      "reliabilityDescription": "Ми перевіряємо та підготовлюємо всіх професіоналів Stepapp",
      "reviewsWithRating": "%{reviews} відгуків із середнім рейтингом %{rating}/5",
      "secureOnlineBooking": "Безпечне онлайн-бронювання",
      "seeAllReviews": "Подивитися всі відгуки",
      "seeMore": "Дивитися більше",
      "servicesWithName": "Привіт, 👋🏻 як ми можемо надати вам більше свободи сьогодні?",
      "startingPrice": "від %{price} злотих",
      "testimonials": "відгуки",
      "title": "Замовлення для",
      "trainedProfessionals": "Тільки підготовлені професіонали",
      "yourSafetyPriority": "Ваша безпека - наш пріоритет.",
      "verifiedAndTrained": "Ми перевіряємо та підготовлюємо всіх професіоналів Stepapp"
    },
    "category": {
      "chooseYourService": "Виберіть свою послугу",
      "contactCustomerSupport": "Зв'яжіться з нашим відділом обслуговування клієнтів.",
      "easyOnlineBooking": "Легка і швидка онлайн-бронювання",
      "haveQuestions": "Маєте запитання?",
      "liabilityInsurance": "Страхування відповідальності до 1 000 000 злотих",
      "otherCategories": "Інші категорії",
      "trainedProfessionals": "Навчені професіонали",
      "whatMakesUsDifferent": "Що робить нас відмінними?"
    },
    "detailsForm": {
      "description": "Ваше ім'я та адреса електронної пошти не будуть видимими для інших.",
      "title": "Заповніть інформацію."
    },
    "dismissBrowser": {
      "goBackToApp": "Повернутися до додатку."
    },
    "editProfile": {
      "aboutMe": "Про мене",
      "changePhoto": "Змінити фото профілю",
      "title": "Редагувати профіль",
      "updateInfo": "Оновити інформацію"
    },
    "flatSize": {
      "description": "Нам потрібно знати квадратну площу вашого будинку, щоб відображати відповідні ціни для вас",
      "title": "Скільки квадратних метрів?",
      "unit": "м2"
    },
    "fullScreenNotification": {
      "reservationButtonTitle": "Перевірити календар",
      "reservationDescription": "Тепер ви можете бачити їх у своєму календарі та контролювати хід робіт.",
      "reservationTitle": "Супер! Ваше бронювання було прийнято."
    },
    "homeDescription": {
      "description": "Те, що ви вводите тут, буде передано вашому працівнику",
      "title": "Додайте інструкції"
    },
    "homeEdit": {
      "addAddress": "Додати адресу",
      "chooseFriendlyName": "Виберіть дружню назву, наприклад: \"Бабусин будиночок\". Ця назва видно лише вам.",
      "confirmDeleteProperty": "Ви впевнені, що хочете видалити квартиру?",
      "deleteProperty": "Видалити квартиру",
      "editAddress": "Редагувати адресу",
      "exactAddress": "Точна адреса",
      "homeType": "Тип помешкання",
      "notEditableNote": "Ви можете змінити лише частину інформації",
      "postalCode": "Поштовий індекс",
      "provideInformation": "Надайте точні адресні дані, щоб ми могли легко знайти ваш будинок.",
      "surface": "Поверхня",
      "type_APARTMENT": "Квартира",
      "type_HOUSE": "Будинок",
      "whatsImportantNote": "Що важливо в вашому домі, коли мова йде про побутові справи?"
    },
    "location": {
      "description": "Ми перевіримо, чи доступні послуги Stepapp у вашому регіоні.",
      "title": "Введіть свій поштовий індекс"
    },
    "login": {
      "alreadyRegistered": "Ви вже маєте обліковий запис Stepapp?",
      "and": "і",
      "firstTime": "Ви вперше користуєтеся нашими послугами?",
      "logInWithAccount": "Або увійдіть до свого облікового запису.",
      "noAccRegister": "Ви ще не маєте облікового запису Stepapp! Найвищий час це виправити!",
      "orderFirstService": "Замовте свою першу послугу",
      "privacyPolicy": "Політика конфіденційності",
      "registerTitle": "Майже готово! Увійдіть або зареєструйтесь, щоб зробити замовлення.",
      "registerYourAccount": "Або зареєструйте новий обліковий запис.",
      "selectingOneOfAbove": "Обравши один із вищезазначених варіантів, ви приймаєте наші",
      "social_apple": "Продовжуйте за допомогою Apple",
      "social_default": "Продовжуйте з номером телефону",
      "social_facebook": "Продовжуйте, використовуючи Facebook",
      "social_google": "Продовжуйте за допомогою Google",
      "termsOfUse": "Умови використання",
      "title": "Увійти або зареєструватися",
      "webRegisterTitle": "Майже готово! Створіть обліковий запис Stepapp або увійдіть в систему."
    },
    "maintenance": {
      "maintenanceBreak": "Технічна перерва",
      "maintenanceContactInfo": "Якщо вам потрібно зв'язатися з нашою службою підтримки, напишіть у чаті на веб-сайті %{landingPageUrl} або на електронну пошту: %{supportEmail}",
      "maintenanceInProgress": "Ми проводимо велике оновлення системи, зараз наші додатки недоступні."
    },
    "myHome": {
      "addInfo": "Додати інформацію",
      "addressNote": "Додайте більше інформації про свій дім, щоб ми могли краще врахувати ваші потреби",
      "notRegistered": "Тут, як зареєстрований користувач, ви зможете додати інформацію про свій будинок, щоб ми краще зрозуміли ваші потреби.",
      "st": "вул.",
      "title": "Мій дім"
    },
    "notes": {
      "addNoteToOrder": "Додайте нотатку до замовлення...",
      "cleaningNotes_cleaning": "Нотатки щодо прибирання",
      "cleaningNotes_massage": "Нотатки щодо масажу",
      "cleaningNotes_other": "Нотатки щодо послуги",
      "exampleNote_cleaning": "“У мене кам'яні стільниці на кухні”\n“У мене чорні фасади шаф, які легко забруднюються”",
      "exampleNote_massage": "“Будь ласка, зробіть ніжніший масаж спини”\n“Будь ласка, уникайте правого коліна після операції”",
      "exampleNote_other": "“Будь ласка, зверніть особливу увагу на ...”",
      "notes": "Нотатки",
      "whatWeShouldKnow_cleaning": "Чи є щось, що нам потрібно знати, щоб відповідати вашим очікуванням?",
      "whatWeShouldKnow_massage": "Чи є щось, що ми повинні знати перед початком послуги? Наприклад, перелік перенесених захворювань тощо.",
      "whatWeShouldKnow_other": "Надайте всю інформацію та інструкції, які допоможуть нам успішно виконати послугу"
    },
    "notAvailableLocation": {
      "notAvailableLocationDescription": "Наші послуги недоступні за цією адресою. Якщо ви хочете, щоб ми з'явилися - дайте нам знати!",
      "notAvailableLocationTtile": "На жаль, ми не в цій локації",
      "proposeCity": "Я хочу мати Stepapp у своєму районі",
      "proposeCityTitle": "Я хочу Stepapp"
    },
    "notificationsCheck": {
      "description": "Не пропустіть інформацію про акції та важливі новини про ваше прибирання.",
      "enableNotifications": "Увімкнути повідомлення",
      "secondDescription": "Увімкніть сповіщення, щоб отримувати інформацію про прогрес вашої послуги.",
      "secondTitle": "Не пропустіть повідомлення.",
      "title": "Хочете дізнатися про знижки?"
    },
    "oneTimePasswordForm": {
      "description": "Введіть код з СМС, яку ми відправили вам за номером %{phoneNumber}",
      "sendAgain": "Повторно відправити",
      "sendAgainIn": "Переадресуйте (%{countdown}s.)",
      "title": "Введіть код з SMS"
    },
    "paymentFailed": {
      "description": "Ми не змогли зняти кошти для оплати вашої підписки. Оновіть метод оплати або напишіть нам, якщо хочете змінити або скасувати підписку.",
      "title": "Платіж не вдалося"
    },
    "payments": {
      "cantRemoveCardDescription": "У вас тривають послуги. Щоб видалити картку, оплатіть прибирання або зв'яжіться з обслуговуванням.",
      "cantRemoveCardTitle": "Не вдається видалити картку",
      "credits": "Кредити",
      "editPaymentInfo": "Ви редагуєте способи оплати для конкретних бронювань в деталях кожного бронювання на екрані “Мої бронювання”",
      "finalized": "Завершено",
      "noTransactions": "Немає транзакцій",
      "paid": "Оплачено",
      "failed": "Не вдалося",
      "savedCards": "Збережені картки",
      "stepappWallet": "Гаманець Stepapp: %{balance}",
      "title": "Платежі",
      "transactionHistory": "Історія операцій"
    },
    "phoneForm": {
      "description_login": "На який був зареєстрований обліковий запис Stepapp",
      "description_register": "Нам потрібно це, щоб забезпечити контакт щодо вашого бронювання.",
      "title": "Введіть свій номер телефону"
    },
    "pickCity": {
      "changeCity": "Змінити місто",
      "changeCountry": "Змінити країну",
      "description": "Stepapp наразі доступний у містах, вказаних нижче.",
      "loginTitle": "Виберіть місто, в якому ви зараз живете.",
      "registerTitle": "Виберіть місто, в якому ви зараз мешкаєте."
    },
    "predefinedProfile": {
      "experienceTitle": "Мій досвід...",
      "lastReviews": "Останні відгуки",
      "recommendationsTitle": "Про мене",
      "finishedJobs": "%{count} виконаних послуг",
      "customerReviews": "%{count} відгуків клієнтів",
      "learnMoreVerification": "Дізнайтеся більше про наш процес перевірки та навчання в Stepapp.",
      "readMore": "Читати більше",
      "weCareWhoComes": "Ми турбуємося про кого входить до вашого будинку.",
      "workerBadgeDescription_training": "%{name} пройшла наше навчання з якості, правил роботи та гігієни.",
      "workerBadgeDescription_safety": "%{name} пройшла нашу перевірку та відповідає вимогам безпеки.",
      "workerBadgeTitle_training": "Навчання",
      "workerBadgeTitle_safety": "Безпека"
    },
    "profile": {
      "removeCard": "Видалити карту",
      "removeCardExplanation": "Видалення карти призведе до її видалення з вашого облікового запису. Вона більше не буде доступна для оплати.",
      "title": "Ваш профіль",
      "totalOrders_zero": "%{count} бронювань",
      "totalOrders_one": "%{count} бронювань",
      "totalOrders_few": "%{count} бронювань",
      "totalOrders_other": "%{count} бронювань"
    },
    "redeemCoupon": {
      "add": "Додати",
      "creditTitle": "Введіть код поповнення",
      "voucherTitle": "Введіть промокод"
    },
    "reviews": {
      "noReviews": "Нам не вдалося завантажити відгуки. Спробуйте ще раз пізніше.",
      "numberOfReviews": "Кількість відгуків",
      "onlyVerifiedReviews": "Тільки перевірені відгуки",
      "orderCleaning": "Замовити прибирання",
      "trueReviews": "Усі наші оцінки були залишені реальними клієнтами після виконаної послуги.",
      "star": "Зірка",
      "star_plural": "Зірки",
      "star_many": "Зірок"
    },
    "service": {
      "additionalServices": "Що ще ми можемо зробити для вас? 🧹",
      "additionalServicesDescription": "Ви можете змінювати регулярність додаткових послуг після першого замовлення.",
      "addressExplanationForVerification": "Введіть адресу, щоб перевірити доступність наших послуг. На наступних кроках ви можете додати додаткову інформацію.",
      "autocompleteInfo": "<0>Введіть повну назву вулиці</0>, щоб перевірити доступність наших послуг. На наступних кроках ви можете додати додаткову інформацію.",
      "averageCleaningTime_cleaning": "Приблизний час прибирання",
      "averageCleaningTime_massage": "Приблизний час масажу",
      "averageCleaningTime_other": "Приблизний час послуги",
      "averageCleaningTimeDescription": "Це орієнтовний час прибирання, оскільки ми знаємо, що кожен будинок інший. Якщо на місці виявиться, що потрібно більше часу - ми заздалегідь повідомимо вас про це та попросимо погодження.",
      "backToHome": "Повернутися на головну сторінку",
      "changeAddress": "Змінити адресу",
      "chooseAddress": "Вибрати адресу",
      "chooseServiceAdjustedToYourNeeds": "Виберіть послугу, що відповідає вашим потребам",
      "happyCustomers": "Задоволені клієнти",
      "howOften": "Як часто?",
      "howOftenDescription": "Завжди той самий надійний фахівець. Спробуйте без строку відмови.",
      "includedInService": "Включено в послугу!",
      "loader": "Щойно, ми обробляємо ваше замовлення",
      "newAddress": "Нова адреса",
      "nextDataAddress": "Наступне - дата та адреса",
      "pickOrCreateAddress": "Виберіть адресу з збережених або додайте нову",
      "priceForService": "Ціна на послугу",
      "reservationError": "Упс! Щось пішло не так",
      "reservationErrorDescription": "Спробуйте ще раз пізніше або зверніться до нашої служби підтримки клієнтів",
      "reservationSuccess": "Супер! Ваше бронювання було підтверджено",
      "reservationSuccessDescription": "Тепер ви можете побачити це в своєму календарі та контролювати прогрес роботи.",
      "reviews": "Відгуки про Stepapp",
      "seeDetails": "Детальніше",
      "seeLastReviews": "Переглянути останні відгуки",
      "selectAvailableOptions": "Виберіть доступні опції, щоб переглянути деталі замовлення",
      "serviceDateInfo": "Безкоштовна зміна дати до %{hours} годин перед початком вашого бронювання.",
      "serviceInsurance": "Ваше прибирання застраховане на суму %{amount}.",
      "serviceProtects": "Бронювання захищене",
      "serviceRange": "Діапазон послуг",
      "showCalendar": "Переглянути календар",
      "showMoreServices": "Більше додаткових послуг",
      "subscriptionExplanationForEdit": "Пам'ятайте, що регулярне прибирання ви зможете змінити пізніше.",
      "whatKindOfServiceYouNeed": "Які послуги вам потрібні?",
      "whatServiceIncludes": "Що включає послуга",
      "whichAddress": "Під якою адресою ми маємо з'явитися?",
      "whichAddressDescription": "Виберіть одну з збережених адрес або додайте нову."
    },
    "serviceAcceptedOverlay": {
      "thankYou": "Дякуємо!",
      "reviewSubmitted": "Ваш відгук успішно надіслано. Кожне зауваження допомагає нам вдосконалювати наші послуги."
    },
    "serviceCalendar": {
      "chooseHour": "Оберіть час, який вам підходить",
      "description": "Виберіть дату та час для початку послуги",
      "title": "Коли ми починаємо?"
    },
    "serviceCard": {
      "canceled": "Скасовано",
      "details": "Деталі",
      "rateAndAccept": "Прийміть і оцініть роботу",
      "showProgress": "Перевірити прогрес",
      "today": "Сьогодні",
      "type_oneTime": "Один раз",
      "type_subscription": "Підписка",
      "worker": "Worker"
    },
    "serviceConfirmation": {
      "completedServicePhoto": "Послуга виконана. Ми зробили фото, яке підтверджує нашу присутність на місці. Воно видно лише вам та нашому обслуговуванні.",
      "doYouAcceptService": "Чи приймаєте ви надання послуги?",
      "report": "Повідомити про проблему"
    },
    "serviceDetails": {
      "additionalInfo": "Додаткові інструкції для робітника",
      "addMoreServices": "Додати більше послуг",
      "calendarChangeDateInfo": "Ми стягнемо плату, якщо ви зміните дату одноразової послуги менше ніж за %{hoursBeforeFee} годин до первісного терміну.",
      "cancellationRule": "Ви можете скасувати та відредагувати послугу до %{hoursBeforeFee} годин до і отримати 100% повернення коштів. Скасування після цього часу може бути пов'язано з додатковими платежами.",
      "cancellationRules": "Політика скасування",
      "cancelService": "Скасуйте цю послугу",
      "changeServiceDetails_cleaning": "Змінити деталі прибирання",
      "changeServiceDetails_massage": "Змінити деталі масажу",
      "changeServiceDetails_other": "Змінити деталі послуги",
      "changeDate": "Змінити дату %{fee}",
      "changeDate2": "Змінити дату",
      "changeDateInfo": "Ви можете змінити дату до 48 годин до дати початку",
      "changeDateIntercomMessage": "Доброго дня, я хотів / хотіла б запросити зміну дати моєї бронювання з ... на ...",
      "changeDetails": "Зміни деталей",
      "chat": "Почати чат",
      "close": "Закрити",
      "confirmDeleteService": "Впевнені? Додаткова послуга не буде виконана",
      "currentPrice": "Поточна ціна",
      "deleteService": "Видалити %{service}?",
      "fee": "(плата %{fee})",
      "fetchReservationError": "Щось пішло не так під час завантаження деталей вашого бронювання. Будь ласка, поверніться до календаря бронювання і спробуйте ще раз. Якщо проблема продовжуватиметься, зв'яжіться з нами.",
      "hour": "Година",
      "hours": "Години",
      "manage": "Керуйте",
      "newPrice": "Нова ціна",
      "orderFor": "Замовлення на:",
      "paymentForm": "Форма оплати",
      "questionNotFound": "Не вдалося знайти питання для оновлення",
      "service": "Сервіс",
      "showCancellationRules": "Переглянути нашу політику скасування",
      "submitChangeConfirmation": "Термін послуги було збережено!",
      "submitChangeLoader": "Ще трохи, ми зберігаємо зміни",
      "submitDetailsConfirmation": "Зміни в послузі було збережено",
      "subscriptionChangeDateInfo": "Підписники мають гнучкість! Для прибирання в рамках підписки зміни ви зробите безкоштовно за 36 годин до послуги!",
      "total": "Всього",
      "totalPaymentInfo": "Оплату ми здійснимо лише в день прибирання, але кошти заблокуємо за 48 годин до терміну.",
      "type_oneTime": "Разові",
      "type_subscription": "Підписка",
      "writeToUs": "напишіть нам"
    },
    "serviceRating": {
      "addPublicReview": "Додати публічний відгук",
      "answersNotShared": "Відповіді не будуть показуватися працівнику.",
      "asYourWorker": "Як ваш працівник?",
      "cleanLeaveRating": "Очистити? Оцініть роботу!",
      "doYouWantToKeep": "Ви хочете зберегти",
      "enterText": "Введіть текст",
      "followedInstructions": "Чи дотримувався працівник ваших інструкцій?",
      "giveYouComment": "Надішліть нам ваші коментарі",
      "howDoYouRateYourExperience": "Як ви оцінюєте свій досвід?",
      "keep": "Зберігати",
      "leaveOpinion": "Надати відгук",
      "leaveOpinionAndRating": "Дайте відгук та залиште рейтинг",
      "leaveRating": "Залишити оцінку",
      "newWorker_description": "Ви побачите нового працівника за 48 годин до наступного сервісу",
      "newWorker_title": "Добре, ми призначимо іншу людину на наступну послугу",
      "optional": "Опціонально",
      "rating1": "Жахлива якість послуги",
      "rating2": "Погано",
      "rating3": "Послуга не відповіла моїм очікуванням",
      "rating4": "Було норм, але потребує покращень",
      "rating5": "Послуга відповідала моїм очікуванням на 100%",
      "sorryToHearThat": "Вибачте, що почули це.",
      "touchStarsToLeaveReview": "Торкніться зірок, щоб залишити відгук.",
      "wasOnTime": "Чи прийшов працівник на час?",
      "wasPrepared": "Чи був працівник готовий до роботи?",
      "wantTheSameWorkerAgain": "Чи хочете ви, щоб цей працівник знову прийшов?"
    },
    "serviceRealization": {
      "chat": "Чат",
      "checkAndConfirm": "Перевірте та прийміть результати",
      "daysLeft": "%{daysLeft} день",
      "daysLeft_plural": "%{daysLeft} днів",
      "info": "Інформація",
      "rateTheServiceWithin": "Оцініть послугу протягом 7 днів",
      "report": "Звіт",
      "serviceCompleted": "Служба завершена!",
      "serviceStatus": "Статус сервісу",
      "statusChoosen": "Очікування робітника...",
      "statusChoosenDescription": "Ми підібрали людину, яка виконає послугу в вашому домі! Для послуг, які надаються в рамках підписки, це завжди буде та сама людина!",
      "statusInProgress": "У процесі послуги",
      "statusInProgressDescription": "Робітниця вже працює над прибиранням! Коли прибирання закінчиться, ми попросимо вас залишити відгук!",
      "statusOnTheWay": "Робітниця в дорозі",
      "statusOnTheWayDescription": "Це вже сьогодні! Незабаром працівниця прибуде оновити ваш дім!",
      "statusWaitingForAccpetance": "Ваше замовлення виконано!",
      "still": "ще"
    },
    "serviceSummary": {
      "addCreditDebitCard": "Додати платіжну картку",
      "additionalServices": "Додаткові послуги",
      "cardPayment": "Оплата карткою",
      "changeCoupon": "Змінити купон",
      "changeDate": "Змінити дату",
      "confirmAndOrder": "Підтвердіть та оформіть замовлення",
      "choosePaymentMethod": "Виберіть спосіб оплати",
      "coupon": "Купон \"%{coupon}\"",
      "description": "Перегляньте своє замовлення знову та перевірте, що все правильно",
      "enterCoupon": "Введіть купон",
      "frequency_EVERY_MONTH": "Кожен місяць",
      "frequency_EVERY_TWO_WEEKS": "Кожні два тижні",
      "frequency_EVERY_WEEK": "Щотижня",
      "frequency_ONE_TIME": "Один раз",
      "grossPriceIncludingVAT": "Вказана ціна є брутто-ціною, яка включає ПДВ %{vat}%",
      "howOften": "Як часто?",
      "importantInformation": "Важлива інформація",
      "iWillBeThere": "Я буду на місці",
      "logIn": "Увійдіть в систему",
      "loginToViewDetails": "Увійдіть або зареєструйтеся, щоб зробити замовлення",
      "orderingFor": "Ваше замовлення",
      "orderingForDescription": "Надана інформація буде збережена у профілі як «Моя адреса»",
      "paidOnServiceDay": "Збір у день виконання",
      "paymentMethod": "Спосіб оплати",
      "paymentNotice": "Після оформлення замовлення ми виконаємо перевірочний платіж на суму вартості замовлення. Ця сума буде повернута не пізніше ніж через 10 хвилин. Основна плата за бронювання стягується лише після завершення послуги.",
      "paymentNow": "Оплата зараз",
      "paymentNowInfo": "Для бронювань з терміном до 48 годин ми блокуємо кошти в момент бронювання.",
      "paymentTerms": "Умови оплати доступні на %{link}",
      "recurringPayment": "Ще один платіж",
      "registerAndOrder": "Зареєструйтеся та зробіть замовлення",
      "sendSMSCode": "Надіслати код СМС",
      "SMSInfo": "Ми відправимо код SMS на вказаний номер телефону. Введіть його, щоб підтвердити вхід або реєстрацію.",
      "subscriptionDiscount": "Знижка за підписку",
      "title": "Опис",
      "toPay": "Сплатити",
      "total": "Загальна",
      "usedVoucher": "Використаний купон",
      "wantEnterCoupon": "Хочете додати купон?",
      "webCardModalTitle": "Це останній крок. Додайте карту та насолоджуйтесь чистим будинком. 🏠",
      "webPaymentInfo": "Адміністратором ваших персональних даних є Stepapp Sp. z.o.o. Stripe є адміністратором платежів. Ми ніколи не будемо збирати кошти без вашої попередньої згоди, а на всі транзакції вам надається 7-денний термін на звернення.",
      "whatIfSomethingsGoesWrong": "Що робити, якщо щось піде не так?",
      "whatIfSomethingsGoesWrongDescription": "Якщо ви не будете задоволені послугою, ми гарантуємо, що вона буде повторно виконана найбільш досвідченими людьми у нашій команді. Звичайно безкоштовно.",
      "whatNow": "Що зараз?",
      "whatNowDescription": "Коли ваше замовлення підтверджено, ми підберемо для вас найкращого робітника в районі на основі ваших переваг. Ви познайомитеся з ним і зможете зв'язатися з ним за 48 годин до початку замовлення.",
      "when": "Коли?",
      "yourCardWillBeLinkedTo": "Ваша карта буде прив'язана до вашого облікового запису Stepapp і використовуватиметься для наступних завантажень замовлених послуг. Ви завжди можете змінити її в налаштуваннях.",
      "yourDataIsSecureThanksTo": "Ваші дані захищені з",
      "yourDataIsSecureThanksToStripe": "Ваші дані в безпеці завдяки Stripe Ltd.",
      "yourStepappWallet": "Ваш гаманець Stepapp"
    },
    "settings": {
      "accountDeleted": "Почато процедуру видалення акаунту. Ми повинні перевірити, чи у вас немає жодних заборгованостей з оплатою. Ваш акаунт та всі пов'язані з ним дані будуть видалені протягом 7 днів.",
      "cancellationRules": "Політика скасування",
      "deleteAccount": "Видалити обліковий запис",
      "discountsAndPromotions": "Наприклад: знижки, акції та спеціальні пропозиції",
      "email": "Електронна адреса",
      "logOut": "Вийти",
      "notifications": "Сповіщення",
      "newsletterAndPromotions": "Новини та промоакції",
      "others": "Інше",
      "phoneNumber": "Номер телефону",
      "privacyPolicy": "Політика конфіденційності",
      "pushNotifications": "Повідомлення в додатку",
      "informationAboutReservation": "Зокрема: інформація про ваші бронювання, повідомлення від служби підтримки",
      "reminderAboutReservation": "Зокрема: нагадування про бронювання, термінові повідомлення від служби підтримки",
      "removeAccountExplanation": "Ваш обліковий запис буде видалено. Цю дію неможливо скасувати.",
      "smsNotifications": "СМС повідомлення",
      "title": "Налаштування",
      "updateEmailAddress": "Оновити електронну адресу",
      "wantToChangePhoneNumber": "Якщо ви хочете змінити номер телефону,"
    },
    "support": {
      "call": "Дзвінок",
      "contactOptions": "Опції контакту:",
      "sendEmail": "Надіслати електронний лист",
      "startChat": "Почати чат",
      "title": "Зв'яжіться з нами"
    },
    "unmatched": {
      "description": "Ми не можемо знайти сторінку, яку ви шукаєте. Спробуйте повернутися на попередню сторінку або зв'яжіться з нами, щоб отримати додаткову інформацію.",
      "title": "Ой,\nтут нічого немає..."
    },
    "welcome": {
      "customerSupportDescription": "Ми доступні для вас 7 днів на тиждень через чат та електронну пошту, і відповімо на будь-яку проблему, яку ви не зможете вирішити через додаток.",
      "customerSupportTitle": "Підтримка клієнтів завжди на зв'язку.",
      "letsStart": "Починаємо!",
      "orderCleaningDescription": "Оцініть прибирання свого будинку, оберіть доступний час і замовте послугу в будь-який час, 24/7.",
      "orderCleaningTitle": "Простий та швидкий спосіб замовити прибирання.",
      "trustedTeamDescription": "Кожна прибиральниця в Stepapp пройшла перевірку під час кількаденного навчання та прибирає відповідно до визначених правил і стандартів.",
      "trustedTeamTitle": "Надійна, досвідчена та професійна команда."
    }
  },
  "validation": {
    "address": "Введіть правильну адресу",
    "blank": "Поле не повинно бути порожнім",
    "city": "Введіть правильне ім'я міста",
    "companyName": "Введіть назву компанії",
    "date": "Виберіть початкову дату послуги",
    "email": "Введіть правильну адресу електронної пошти",
    "firstName": "Введіть своє ім'я",
    "homeType": "Виберіть тип будинку",
    "hour": "Виберіть час початку послуги",
    "invalid": "Введіть правильні дані",
    "keyInfo": "Опишіть, де ви залишите ключ",
    "lastName": "Введіть своє прізвище",
    "maxSurface": "Максимально підтримувана площа становить %{maxSize}м2",
    "minSurface": "Мінімальна площа становить %{minSize}м2",
    "nipNumber": "Введіть правильний код NIP",
    "numberOrHousing": "Вкажіть номер квартири/будинку",
    "phone": "Введіть правильний номер телефону",
    "pickAddress": "Виберіть адресу",
    "pickOption": "Виберіть одну з опцій",
    "postalCode": "Введіть правильний / підтримуваний поштовий індекс",
    "required": "Обов'язково",
    "smsOrPhoneNumber": "Невірний код SMS або номер телефону"
  },
  "verification": {
    "closePage": "Ця сторінка автоматично закриється через 10 секунд",
    "paymentVerificationConfirmed": "Ваш платіж був підтверджений",
    "paymentVerificationFailed": "Підтвердження не вдалося",
    "retryVerification": "Спробуйте ще раз або скористайтеся іншим методом оплати."
  }
}
